import { useMemo } from "react";
import { bool } from "prop-types";
import { observer } from "mobx-react";
import { PriceFormats, Totals } from "@repo/utils";
import {
  TotalWorkTypeBufferTooltip,
  useEstimateEditorSettings,
  useEstimateStructure,
  useVisibilityModeCellClassName
} from "@tools";
import { TotalContainer } from "../components";

export const TotalCost = observer(({
  isRevenue,
  ...containerProps
}) => {
  const structure = useEstimateStructure();
  const { allowEdition } = useEstimateEditorSettings();
  
  const {
    displayTotalPrice,
    displayTotalPriceMax,
    showMaxTotalPrice,
    usedBuffers,
    showFixedDecimalPrices,
  } = structure;
  const {
    currencyObj,
    roundPrice,
    priceFormat,
    maxValuesAsBuffer
  } = structure.settings;
  const { hideTotalCost } = structure.visibility;
  const className = useVisibilityModeCellClassName(hideTotalCost);
  
  const displayUsedBuffers = useMemo(() => (
    allowEdition && displayTotalPrice && structure.hasUsedWorkTypeBuffers()
  ), [ displayTotalPrice, allowEdition, usedBuffers ]);
  
  return (
    <TotalContainer
      totalName={ isRevenue ? "revenue" : Totals.COST }
      min={displayTotalPrice}
      max={displayTotalPriceMax}
      symbolStart={currencyObj.symbolStart}
      symbolEnd={currencyObj.symbolEnd}
      showAllSymbols
      americanFormat={priceFormat === PriceFormats.AMERICAN}
      showMaxValue={showMaxTotalPrice}
      textSmaller={isRevenue}
      showDecimals={!roundPrice}
      fixedDecimalScale={showFixedDecimalPrices}
      allowNegative
      className={className}
      visibilityHidden={hideTotalCost}
      setVisibility={structure.visibility.setHideTotalCost}
      applySuffixSpacing
      minTooltipMessage={ displayUsedBuffers && !maxValuesAsBuffer && <TotalWorkTypeBufferTooltip isPrice /> }
      maxTooltipMessage={ displayUsedBuffers && <TotalWorkTypeBufferTooltip isPrice isMax /> }
      { ...containerProps }
    />
  );
})

TotalCost.propTypes = {
  showDivider: bool,
  revenue: bool,
  compact: bool,
}